<template>
  <div style="text-align: left;" id="left_column">
    <div style="height: 160px;">
      <div class="center_vertical">
        <select v-if="permitedLinks" @change="onChange" dir="rtl">
          <option></option>
          <option
            v-for="owner in activeAdmins"
            :key="owner.id"
            :selected="owner.id == $utils.getOwner().id"
            :value="owner.id"
            >{{ owner.full_name }}</option
          ></select
        >
        <p class="large_font_size">Hello {{ owner_name }} :) 🚀</p>
        <div class="is-uppercase">
          <router-link class="button is-info" :to="{ name: 'daily-report' }">
            <p>Daily Report</p>
          </router-link>
        </div>
      </div>
    </div>
    <div v-if="recruiterQaEnabled" class="recruiter_qa_top">
      <button
        @click="openRecruiterQa"
        class="button is-primary is-fullwidth recruiter_qa_menu_item"
        :class="{ 'has_unread': recruiterQaUnread > 0 }">
        דבר עם המערכת
        <span v-if="recruiterQaUnread > 0" class="recruiter_qa_badge" :aria-label="recruiterQaUnread + ' פניות עם עדכון שלא נקרא'">{{ recruiterQaUnread }}</span>
      </button>
      <router-link
        v-if="recruiterQaSupervisor"
        :to="{ name: 'admin-recruiter-qa' }"
        class="button is-primary is-light is-small is-fullwidth recruiter_qa_admin_menu_item">
        פניות העובדות
      </router-link>
    </div>
    <div>
      <FeedAlert v-model="alertInProgressId" />
    </div>
    <div class="router-links">
      <div v-if="customPermit" class="menu_item_container">
        <router-link :to="{ name: 'today-applicants' }">
          <p>Today’s applicants</p>
        </router-link>
      </div>
      <div class="menu_item_container">
        <router-link :to="{ name: 'system' }">
          <p>System</p>
        </router-link>
      </div>
      <div v-if="permitedLinks && !lowerRank" class="menu_item_container">
        <router-link :to="{ name: 'admin' }">
          <p>Admin</p>
        </router-link>
      </div>
      <div class="menu_item_container">
        <router-link :to="{ name: 'recruiters' }">
          <p>Recruiters</p>
        </router-link>
      </div>
      <div class="menu_item_container">
        <router-link :to="{ name: 'admin-companies', query: { sort: '-id' } }">
          <div class="is-flex">
            <p>Companies</p>
            <a @click.prevent="createCompany" class="button is-info create_company">+</a>
          </div>
        </router-link>
      </div>
      <div v-if="!lowerRank" class="menu_item_container">
        <router-link :to="{ name: 'company-offers' }">
          <p>Company Offers</p>
        </router-link>
      </div>
      <div v-if="!lowerRank" class="menu_item_container">
        <router-link :to="{ name: 'stargate-log' }">
          <p>לוג סטארגייט</p>
        </router-link>
      </div>
      <div v-if="!lowerRank" class="menu_item_container">
        <router-link :to="{ name: 'chatbot-proposals' }">
          <p>הצעות צ'אטבוט</p>
        </router-link>
      </div>
      <div v-if="!lowerRank" class="menu_item_container">
        <router-link :to="{ name: 'company-followup' }">
          <p>פולואפ מעסיקים</p>
        </router-link>
      </div>
      <div v-if="!lowerRank" class="menu_item_container">
        <router-link :to="{ name: 'sending-policies' }">
          <p>מדיניות שליחה</p>
        </router-link>
      </div>
      <div v-if="!lowerRank" class="menu_item_container">
        <router-link :to="{ name: 'blocked-candidates' }">
          <p>מועמדים חסומים</p>
        </router-link>
      </div>
      <div class="menu_item_container">
        <router-link :to="{ name: 'admin-intake-assist' }">
          <p>להשלים ראיון בטלפון</p>
        </router-link>
        <router-link v-if="intake_assist_tasks > 0" :to="{ name: 'admin-intake-assist' }"
                     class="count_only intake_assist_count_only" title="שיחות צ'אטבוט שממתינות להשלמה בטלפון">{{
          intake_assist_tasks
        }}</router-link>
      </div>
      <div class="menu_item_container">
        <router-link :to="{ name: 'admin-positions', query: { statuses: 'active', is_hot: 'true' } }">
          <p>Positions</p>
        </router-link>
      </div>
      <div v-if="lowerRank" class="menu_item_container mb-3">
        <a @click.prevent="createApplicant" class="button is-info m-0">create new applicant</a>
      </div>
      <div v-if="!lowerRank" class="menu_item_container">
        <router-link
          :to="{ name: 'admin-applicants', query: { applicant_status: 'unvetted' } }"
        >
          <p>Not Vetted</p>
        </router-link>
      </div>
      <div v-if="!lowerRank" class="menu_item_container">
        <router-link :to="{ name: 'admin-applicants', query: { refresh_key: getRefreshKey } }" replace>
          <p>Applicants</p>
        </router-link>
      </div>
      <div v-if="!lowerRank" class="menu_item_container">
        <router-link
          :to="{
            name: 'admin-applicants',
            query: { owner: $utils.getOwner().name }
          }"
        >
          <p>My Applicants</p>
        </router-link>
      </div>
      <div v-if="!lowerRank" class="menu_item_container">
        <div>
          <router-link
            :to="{
              name: 'admin-offers',
              query: { statuses: 'awaiting_company', sort: '-sent_at' }
            }"
          >
            <p>Offers</p>
          </router-link>
          <div class="count_onlies">
            <div class="is-flex is-flex-wrap-wrap">
              <router-link v-if="total_offers" class="count_only" style="margin-left: 0;" title="Total Offers" :to="{ name: 'admin-offers', query: { statuses: 'awaiting_company', sort: '-sent_at' } }">{{
                total_offers
              }}</router-link>
              <router-link v-if="offers_hot_positions" :to="{ name: 'admin-offers', query: { statuses: 'awaiting_company', is_hot_positions: 'true', sort: '-sent_at' } }"
                           class="count_only is_hot_count_only" title="Offers for hot positions">{{
                offers_hot_positions
              }}</router-link>
            </div>
            <div class="is-flex is-flex-wrap-wrap">
              <router-link v-if="offers_strong_status" :to="{ name: 'admin-offers', query: { statuses: 'awaiting_applicant_strong', sort: '-updated_at' } }"
                           class="count_only vetted_count_only" title="Offers of strong statuses">{{
                offers_strong_status
              }}</router-link>
              <router-link v-if="vetted_offers" :to="{ name: 'admin-offers', query: { statuses: 'awaiting_company', applicant_status: 'completed,vetted', sort: '-sent_at' } }"
                           class="count_only is_star_count_only" title="Offers of vetted applicants">{{
                vetted_offers
              }}</router-link>
              <router-link v-if="system_strong_offers !== undefined" :to="{ name: 'admin-offers', query: { statuses: 'system_strong', sort: '-updated_at' } }"
                           class="count_only system_strong_count_only" title="System strong offers (בועה סטרונג מערכת)">{{
                system_strong_offers || 0
              }}</router-link>
              <router-link v-if="intake_review_offers" :to="{ name: 'admin-offers', query: { statuses: 'awaiting_admin_intake', sort: '-updated_at' } }"
                           class="count_only intake_review_count_only" title="ממתין לבדיקת יועצת (בועה כתומה)">{{
                intake_review_offers
              }}</router-link>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!lowerRank" class="menu_item_container">
        <router-link :to="{ name: 'admin-alerts', query: { statuses: 'active', designators: 'send_cv', sort: '-priority', past: 'true' } }">
          <p>Feed</p>
        </router-link>
        <router-link v-if="priority_notifications" class="count_only is_hot_count_only" title="Notifications" :to="{ name: 'admin-alerts', query: { statuses: 'active', sort: '-priority', past: 'true', priority_notifications: 'true' } }">{{
          priority_notifications
        }}</router-link>
      </div>
      <div class="sub_links menu_item_container">
        <div>
          <div v-for="(counter, group) in feed_counters" :key="group">
            <div class="sub_link" v-if="!lowerRank || group == 'follow_up'">
              <router-link :to="{ name: 'admin-alerts', query: { statuses: 'active', designators: getDesignatorsByGroupName(group).join(','), past: 'true', sort: getSortByGroup(group), group_by_applicant: groupByApplicant(group) } }">
                <p>{{group}}</p>
              </router-link>
              <a v-if="counter.general > 0" class="count_only">{{
                counter.general
              }}</a>
              <a v-if="counter.personal > 0" class="count_only count_only_personal">{{
                counter.personal
              }}</a>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!lowerRank" class="menu_item_container">
        <router-link :to="{ name: 'admin-stats' }"><p>Stats</p></router-link>
      </div>
    </div>
    <div class="vertical_space"></div>
    <div class="vertical_space"></div>
    <div>
      <div class="mb-4">
        <button class="button is-success" @click="openWhatsapp">Open WA</button>
      </div>
      <div>
        <div>
          <a @click="preLogout" class="button is-danger is-outlined" :class="{ 'is-loading': is_logging_out }">סיימתי להיום</a>
        </div>
      </div>
      <div v-if="!isNotificationsPermissionAllowed()">
        <div class="vertical_space"></div>
        <div class="vertical_space"></div>
        <a @click="initFirebase()" class="button is-info is-outlined allow_notifications_permission">Request Notifications Permission</a>
      </div>
    </div>
  </div>
</template>
<script>
// libraries
import { mapMutations, mapGetters, mapActions } from 'vuex'
import TimeHelper from '@/custom/classes/time_helper.js'
import Firebase from '@/custom/classes/firebase.js'
import FeedAlert from '@/components/FeedAlert'
import { bus } from '@/custom/classes/bus.js'

export default {
  name: 'LeftMenu',
  components: {
    FeedAlert
  },
  data () {
    return {
      time_helper: new TimeHelper(),
      firebase: new Firebase(),
      total_offers: undefined,
      offers_hot_positions: undefined,
      vetted_offers: undefined,
      priority_notifications: undefined,
      offers_strong_status: undefined,
      system_strong_offers: undefined,
      intake_review_offers: undefined,
      intake_assist_tasks: undefined,
      feed_counters: {},
      is_logging_out: false,
      owner_name: this.$utils.getOwner().name,
      alertInProgressId: null
    }
  },
  created () {
    this.getLocalStorage()
    this.getCountOnlies()
    this.checkIfLogout()
    // Views that change counted work (e.g. intake assist tasks) emit this.
    bus.$on('refresh_counters', this.getCountOnlies)
  },
  beforeDestroy () {
    bus.$off('refresh_counters', this.getCountOnlies)
  },
  computed: {
    ...mapGetters('admins', ['activeAdmins']),
    ...mapGetters('feedDesignators', ['feedDesignators']),
    ...mapGetters('recruiterQa', { recruiterQaEnabled: 'enabled', recruiterQaUnread: 'unreadCount', recruiterQaSupervisor: 'supervisor' }),
    getRefreshKey () {
      if (this.$route.query.refresh_key == undefined) {
        return 1
      }
      return (this.$route.query.refresh_key) + 1
    },
    customPermit () {
      const permission_level = this.$utils.getOwner().permission_level
      return [6, 7, 8, 0].includes(permission_level)
    },
    permitedLinks () {
      const permission_level = this.$utils.getOwner().permission_level
      return permission_level >= 8 || permission_level == 0
    },
    lowerRank () {
      const permission_level = this.$utils.getOwner().permission_level
      return permission_level < 6 && permission_level > 1
    }
  },
  methods: {
    ...mapActions('admins', ['getLocalStorage']),
    onChange (e) {
      const owner = this.activeAdmins.find(a => a.id === parseInt(e.target.value))
      this.owner_name = owner.full_name
      this.$utils.setOwner(owner)
    },
    getCountOnlies () {
      this.$network_utils.getCounters().then(response => {
        this.total_offers = response.total_offers
        this.offers_hot_positions = response.offers_hot_positions
        this.vetted_offers = response.vetted_offers
        this.offers_strong_status = response.offers_strong_status
        this.system_strong_offers = response.system_strong_offers
        this.intake_review_offers = response.intake_review_offers
        this.intake_assist_tasks = response.intake_assist_tasks
        this.priority_notifications = response.priority_notifications
        this.feed_counters = response.feed_counters
      })
    },
    preLogout () {
      localStorage.setItem('logout', true)
      this.preLogoutOpenModal()
    },
    preLogoutOpenModal () {
      const isLogout = localStorage.getItem('logout')
      const isFirstScreen = isLogout && isLogout == 'true'
      this.create({
        designator: 'modal-daily-summary',
        component_name: 'ModalDailySummary',
        modal_title: 'Daily Summarize',
        persistent: true,
        show_close_button: false,
        ignore_escape_button: true,
        is_center_modal: true,
        modal_width: isFirstScreen ? 750 : 1400,
        props: {
          isFirstScreen: isFirstScreen,
          onSubmit: async (id) => {
            localStorage.removeItem('logout')
            this.removeModalById(id)
            await this.logout()
          }
        }
      })
    },
    openWhatsapp () {
      this.create({
        designator: 'whatsapp-master-modal',
        component_name: 'ModalMasterWhatsapp',
        modal_title: 'Messanger',
        modal_width: 1200,
        is_center_modal: true
      })
    },
    checkIfLogout () {
      const isLogout = localStorage.getItem('logout')
      if (isLogout) {
        this.preLogoutOpenModal()
      }
    },
    getDesignatorsByGroupName (group_name) {
      const group = this.feedDesignators.filter(feed_designator => feed_designator.group == group_name)[0]
      if (group) return group.designators
      return []
    },
    groupByApplicant (group) {
      return group == 'follow_up' ? 'TRUE' : undefined
    },
    getSortByGroup (group) {
      return group == 'follow_up' ? '-timing' : '-priority'
    },
    isNotificationsPermissionAllowed () {
      return Notification.permission === 'granted'
    },
    initFirebase () {
      new Firebase().init()
    },
    async logout () {
      this.is_logging_out = true
      const alerts = await this.$network_utils.getAllAlerts({ statuses: 'in_progress', owner: this.$utils.getOwner().name })
      alerts.forEach(alert => {
        this.$network_utils.updateAlert({ id: alert.id, status: 'active' })
      })
      this.$network_utils.postStat({
        title: 'Recruiter Logged Out',
        designator: 'recruiter_logout',
        content: `${this.$utils.getOwner().name} התנתק/ה`,
        status: 'done',
        owner: this.$utils.getOwner().name,
        priority: 5,
        resource_id: 1,
        resource_type: 'Admin'
      }).then(() => {
        this.is_logging_out = true
        return this.$network_utils.updateAdmin({ id: this.$utils.getOwner().id, user_id: this.$utils.getOwner().user_id, is_online: false })
      }).then(() => {
        if (!this.alertInProgressId) return
        return this.$network_utils.updateAlert({ id: this.alertInProgressId, owner: 'NULL', status: 'active' })
      }).then(() => {
        this.is_logging_out = false
        this.clearLocalStorage()
        this.$router.push({ name: 'login' })
      })
    },
    clearLocalStorage () {
      localStorage.removeItem('owner')
      localStorage.removeItem('admin_list')
      localStorage.removeItem('auth')
    },
    createCompany () {
      this.create({
        designator: 'create-company-step-one',
        component_name: 'CreateCompanyStepOne',
        ignore_escape_button: true,
        modal_title: 'Create new Company'
      })
    },
    createApplicant () {
      this.create({
        designator: 'create-applicant',
        component_name: 'ApplicantCreateForm',
        ignore_escape_button: true,
        modal_title: 'Create new Applicant'
      })
    },
    openRecruiterQa () {
      this.$store.dispatch('recruiterQa/openDrawer')
    },
    ...mapMutations('modals', ['create', 'removeModalById', 'remove'])
  }
}
</script>
<style scoped>
  .recruiter_qa_top{
    margin: 6px 0 4px;
  }
  .recruiter_qa_top .button + .button{
    margin-top: 6px;
  }
  .recruiter_qa_menu_item{
    position: relative;
    font-weight: bold;
    font-size: 15px;
    direction: rtl;
  }
  .recruiter_qa_menu_item.has_unread{
    box-shadow: 0 0 0 2px #ffdd57;
  }
  .recruiter_qa_badge{
    display: inline-block;
    min-width: 20px;
    height: 20px;
    line-height: 20px;
    border-radius: 10px;
    background-color: #c9302c;
    color: white;
    font-size: 12px;
    font-weight: bold;
    text-align: center;
    padding: 0 6px;
    margin-right: 8px;
  }
  .allow_notifications_permission{
    font-size: 10px;
  }
  .count_onlies .count_only{
    margin: 0;
    margin-right: 5px;
    margin-top: 5px;
  }
  .sub_link{
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 10.5px;
    height: 30px;
  }
  .sub_links{
    padding: 0 !important;
  }
  .sub_links .count_only{
    background-color: #3273dc;
    min-width: 20px;
    height: 20px !important;
  }
  .sub_links .count_only_personal{
    background-color: #B64D3A;
  }
  .router-links {
    margin-top: 10px;
  }
  .router-links .menu_item_container {
    padding-top: 7px;
    padding-bottom: 7px;
    display: flex;
  }
  #left_column {
    position: fixed;
    overflow-y: auto;
    padding: 18px;
    box-sizing: border-box;
    background-color: var(--color-header);
    float: left;
    border-right: 1px solid var(--color-header);
    color: white;
    width: var(--left-column-width);
    height: 100%;
  }
  .router-links .count_only_resource {
    margin-bottom: 0 !important;
  }
  .count_only {
    font-size: 12px;
    margin-left: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 22px !important;
    min-width: 22px;
    padding: 6px 7px;
    border-radius: 30px;
    background-color: orange;
  }
  .is_star_count_only{
    background-color: #4F9EC4;
  }
  .is_hot_count_only{
    background-color: #B64D3A;
  }
  .vetted_count_only{
    background-color: #a64ca6;
  }
  .intake_review_count_only{
    background-color: #EA580C;
  }
  .system_strong_count_only{
    background-color: #0F766E;
  }
  .intake_assist_count_only{
    background-color: #B45309;
  }
  .create_company {
    margin-left: 10px;
    font-size: 10px;
  }
</style>
